import api from '@/api/user'
import { errorHandler } from "../exports/error_management"

const state = {
    items: [],
    pagination: null,
}

const mutations = {
    set(state, payload) {
        state.items = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
}

const actions = {
    create(context, payload) {
        return api
            .create(
                payload.firstName,
                payload.lastName,
                payload.email,
                payload.roles,
                payload.password
            )
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },
    fetch(context, payload) {
        return api
            .fetch(payload.query, payload.page)
            .then(result => {
                let users = result.data.success.data.data.map(x => {
                    x.firstName = x.first_name
                    x.lastName = x.last_name
                    delete x.first_name
                    delete x.last_name

                    return x
                })
                context.commit('set_users', users)
                let pag = result.data.success.data
                context.commit('set_pagination', {
                    page: pag.current_page,
                    pageSize: pag.per_page,
                    total: pag.total,
                })
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    update(context, payload) {
        return api
            .update(
                payload.userId,
                payload.firstName,
                payload.lastName,
                payload.roles
            )
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },
    delete(context, id) {
        return api
            .delete(id)
            .then(() => {
                context.commit('fleet/delete', id)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}